import { constants } from "src/shared/constants";
import {
  FAQS,
  FooterLinks,
  NavSubmenuLinks,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const newyorkmets_upgrades: TTeamConfig = {
  TEAM_SCHEMA: "newyorkmets_upgrades",
  TEAM_FULL_NAME: "New York Mets",
  BROWSER_TITLE: "New York Mets Upgrades",
  CLIENT_ID: "dJQGeO3S8CEHipn0nxVuNaRb9hUWAAji4yYGs0RG4Hsx7TdK",
  VENDOR: constants.vendorUUIDs.ticketsdotcom,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#002D72",
    COLORS_SECONDARY: "#FF5910",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,
    ACCOUNT_MANAGER_URL: "https://bp.mlb.com/Wallet",
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    DISABLE_SIT_WITH_FRIENDS: true,

    NAV_MENU: {
      HIDE_AUTH_BUTTONS: true,
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
    },

    FOOTER: {
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
      LINKS: FooterLinks,
    },
  },

  AUTH_PAGE_SETTINGS: {
    HIDE_ACCOUNT_DETAILS: true,

    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  LANDING_PAGE_SETTINGS: {
    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      IS_EXPANDED_CARD: true,
    },

    HIDE_PASSES: true,

    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      MAX_HEIGHT: "420px",
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },

    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },

    ADD_ON: {
      ADD_ON_PURCHASE_SUCCESS_MESSAGE: {
        TITLE: () => "Upgrade Confirmed!",
        DESCRIPTION: () =>
          "Thank you! You have successfully claimed an upgrade for today's Mets game. Your tickets are now available in the MLB Ballpark app.",
      },
    },

    ZERO_STATE: {
      TITLE: "No Available Upgrades",
      DESCRIPTION:
        "You must have a valid game ticket to today's game in order to participate in this exclusive opportunity.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLE_SAVE_CARD: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Mets/STMUpgrade_1920x450.jpg",
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Mets/STMUpgrade_1920x450.jpg",
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Mets/new-york-mets-logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/NY%20Mets/new-york-mets-background.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
